/**
 * CategoryListContainer
 * --
 */
import React, { useEffect } from 'react';
import CategoryListPresenter from './CategoryListPresenter';
import { useGetMenus } from 'hooks/MenuHooks';
import {
  useCreateProductCategory,
  useGetMenuCategories,
  // useGetProductCategory,
  useUpdateProductCategory,
  useDeleteProductCategory,
} from 'hooks/ProductCategoryHooks';
import { LoadingPage } from 'components';
import MessageAlert from 'utils';
import { useUserStack } from 'store';

const CategoryListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== MUTATE ===== */
  const { createProductCategory } = useCreateProductCategory();
  const { updateProductCategory } = useUpdateProductCategory();
  const { deleteProductCategory } = useDeleteProductCategory();

  /* ===== DATA ===== */
  const userInfo = useUserStack();
  const { data: Menus } = useGetMenus();
  const { data: Categories } = useGetMenuCategories();
  /* ===== STATE ===== */
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);
  // 정제된 데이터
  const [data, setData] = React.useState(null);
  const [categoriesOrder, setCategoriesOrder] = React.useState();

  // 모달
  const [isOpened, setIsOpened] = React.useState(false);
  const [modalType, setModalType] = React.useState(false);
  const [modalData, setModalData] = React.useState({
    menu: {},
    category: {},
  });
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */

  /**
   * 모달 핸들러
   * --
   */
  const handleModal = (open, type = '', data = {}) => {
    setModalData((prev) => ({
      ...prev,
      [type]: data,
    }));

    setIsOpened(!open);
    setModalType(type);
  };

  /**
   * 데이터 바인딩 함수
   * --
   * @param {string} target
   * @param {*} value
   * @param {object} object
   * @param {*} callback
   */
  const handleChange = (t, v, o) => {
    let newData = modalData[o];

    newData[t] = v;
    const d = {
      ...modalData,
      o: { ...newData },
    };

    setModalData(d);
  };

  /**
   * 메뉴 삭제
   * --
   */
  const handleDeleteSelected = async (idx) => {
    if (!idx) {
      MessageAlert.warning('삭제할 항목을 선택해주세요.');
      return;
    }
    try {
      setIsLoading(true);

      const { status } = await deleteProductCategory(idx);

      if (status === 200) {
        MessageAlert.success('선택한 카테고리가 삭제되었습니다.');
        window.location.reload();
      } else {
        MessageAlert.error(
          '카테고리와 적용된 다른 데이터를 확인하고 다시 시도해주세요.'
        );
      }
    } catch (err) {
      MessageAlert.error(
        '카테고리와 적용된 다른 데이터를 확인하고 다시 시도해주세요.'
      );
      console.error('[DELETE EVENT ERROR CATEGORY]:', err);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 데이터 생성
   * --
   * @param {string} t
   * @param {string} s
   * @returns
   */
  const handleSubmit = async (t, s = 'CREATE', selectedItem = null) => {
    // console.log('modalData', modalData);
    // console.log('nritu', nutritionalInfo);
    // console.log('options', options);
    // 생성 타입 대문자 변환
    const type = t.toLocaleUpperCase();

    // 함수 타입 대문자 변환
    const submit = s.toLocaleUpperCase();

    // 생성 타입 정의
    const submitType = {
      CATEGORY: '카테고리',
      CREATE: '생성',
      UPDATE: '수정',
    };

    // NOTE: 데이터 유효성 검사 및 데이터 리턴
    const data = selectedItem
      ? handleValidateCheck('UPDATECATE', selectedItem)
      : handleValidateCheck(type);
    console.log(data);
    if (!data) return;

    // NOTE: 생성/수정 함수 정의
    const submitFunc = {
      CATEGORY: {
        CREATE: createProductCategory,
        UPDATE: updateProductCategory,
      },
    };

    try {
      // 로딩 처리
      setIsLoading(true);

      // 데이터 생성/수정
      const { status } = await submitFunc[type][submit]({
        ...data,
      });

      // }
      if (status === 200) {
        MessageAlert.success(
          `성공적으로 ${submitType[type]}이/가 ${submitType[submit]}되었습니다.`
        );
        setModalData((prev) => ({ ...prev, t: {} }));
        setIsOpened(false);
        return;
      }

      MessageAlert.warning(
        `${submitType[type]}을/를 ${submitType[submit]}하는데 실패하였습니다.`
      );
    } catch (err) {
      MessageAlert.error(
        `${submitType[type]}을/를 ${submitType[submit]}하는데 오류가 발생하였습니다.`
      );
      console.error(`[CREATE ${type}] ERROR : `, err);
      throw err;
    } finally {
      // 로딩 처리
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
      submit === 'UPDATE' && window.location.reload();
    }
  };

  /**
   * 유효성 검사
   * --
   * @param {string} t
   * @returns
   */
  const handleValidateCheck = (t, selectedItem = null) => {
    if (t === 'CATEGORY') {
      // 카테고리 유효성 검사
      const { product_category_name } = modalData?.category;

      if (!product_category_name) {
        MessageAlert.warning('카테고리명을 입력해주세요.');
        return false;
      }
      if (product_category_name?.length > 20) {
        MessageAlert.warning('카테고리명의 길이를 확인해주세요.');
        return false;
      }

      return {
        ...modalData?.category,
        application_status: 'APPROVE',
        type: 'MENU',
        order: Categories?.data?.length + 1,
        // NOTE: 쇼브매지idx 추가
        shop_information_id: userInfo?.shop_information_id,
      };
    } else if (t === 'UPDATECATE') {
      // 카테고리 유효성 검사
      const { product_category_name } = selectedItem;

      if (!product_category_name) {
        MessageAlert.warning('카테고리명을 입력해주세요.');
        return false;
      }
      if (product_category_name?.length > 20) {
        MessageAlert.warning('카테고리명의 길이를 확인해주세요.');
        return false;
      }
      return {
        ...selectedItem,
      };
    }
  };

  const handleDrop = (updatedItems) => {
    const updateOrder = (items, parentOrder = 0) => {
      return items.map((item, index) => {
        const newOrder = parentOrder + index + 1; // 새로운 order 계산
        const updatedItem = {
          ...item,
          order: newOrder, // order 값 업데이트
        };

        // 하위 항목에 대해 재귀적으로 order 업데이트
        if (updatedItem.children && updatedItem.children.length > 0) {
          updatedItem.children = updateOrder(updatedItem.children, newOrder);
        }

        return updatedItem;
      });
    };

    const orderedItems = updateOrder(updatedItems);

    setCategoriesOrder(orderedItems); // 상태 업데이트
  };

  /**
   * 순서 변경
   * --
   */
  const handleUpdateOrder = async () => {
    const confirm = window.confirm(`변경한 순서를 저장하시겠습니까?`);

    if (confirm) {
      const flattened = [];

      categoriesOrder?.forEach((category) => {
        flattened.push({
          product_category_id: category.product_category_id,
          order: category.order,
        });
        // 하위 카테고리가 있을 경우
        if (category?.children?.length) {
          category?.children?.forEach((subCategory) => {
            flattened.push({
              product_category_id: subCategory.product_category_id,
              order: subCategory.order,
            });
          });
        }
      });

      try {
        setIsLoading(true);

        // map과 Promise.all로 요청 처리
        const responses = await Promise.all(
          flattened?.map(async (item) => {
            const { product_category_id, order } = item;
            const payload = { product_category_id, order };

            try {
              const { status } = await updateProductCategory(payload);

              if (status !== 200) {
                throw new Error(
                  `Failed to update product_category_id: ${product_category_id}`
                );
              }
              return { success: true, product_category_id };
            } catch (error) {
              console.error(`[UPDATE SHOPMENU ITEM ERROR]:`, error);
              MessageAlert.error(`순서 변경 실패: ${product_category_id}`);
              return { success: false, product_category_id };
            }
          })
        );

        // 모든 요청이 성공했는지 확인
        const isSuccess = responses.every((res) => res.success);

        if (isSuccess) {
          MessageAlert.success('순서가 변경되었습니다.');
          window.location.reload();
        } else {
          MessageAlert.error('일부 순서 변경에 실패했습니다.');
        }
      } catch (err) {
        MessageAlert.error('순서 변경이 실패했습니다.');
        console.error('[UPDATE SHOPMENU ERROR]:', err);
      } finally {
        setIsLoading(false);
      }
    }
  };
  /* ===== HOOKS ===== */
  useEffect(() => {
    if (!Categories?.data || !Menus?.data) return; // 데이터가 없으면 실행하지 않음

    // const NewCategories = Categories?.data?.filter(
    //   (item) => item.application_status === 'APPROVE'
    // );
    // 상위 카테고리 및 하위 카테고리 그룹화
    const categoryMap = Categories?.data?.reduce((acc, category) => {
      if (!category.parents_id) {
        acc[category.product_category_id] = {
          ...category,
          key: category?.product_category_id, // key 추가
          title: category?.product_category_name, // title 추가
          children: [],
          menus: [], // 상위 카테고리의 메뉴 배열 초기화
        };
      } else {
        const parentCategory = acc[category.parents_id];
        if (parentCategory) {
          parentCategory.children.push({
            ...category,
            key: category?.product_category_id, // key 추가
            title: category?.product_category_name, // title 추가
            menus: [], // 하위 카테고리의 메뉴 배열 초기화
          });
        }
      }
      return acc;
    }, {});

    // 메뉴를 해당 카테고리 또는 하위 카테고리에 매핑
    Menus.data.forEach((menu) => {
      if (menu.application_status !== 'APPROVE') return;
      const category = categoryMap[menu.product_category_id];
      if (category) {
        // 상위 카테고리의 메뉴 추가
        category.menus.push(menu);
      } else {
        // 하위 카테고리의 메뉴 추가
        const parentCategory = Object.values(categoryMap).find((c) =>
          c.children.some(
            (subCategory) =>
              subCategory.product_category_id === menu.product_category_id
          )
        );
        if (parentCategory) {
          const subCategory = parentCategory.children.find(
            (subCategory) =>
              subCategory.product_category_id === menu.product_category_id
          );
          if (subCategory) {
            subCategory.menus.push(menu);
          }
        }
      }
    });

    // 카테고리 데이터를 배열로 변환하여 업데이트
    const newData = Object.values(categoryMap)?.sort(
      (a, b) => (a.order || 0) - (b.order || 0)
    );

    // 하위 카테고리를 정렬
    Object.values(categoryMap).forEach((category) => {
      category.children.sort((a, b) => (a.order || 0) - (b.order || 0));
    });

    // 기존 데이터와 비교 후 상태 업데이트
    if (JSON.stringify(newData) !== JSON.stringify(data)) {
      setData(newData);
    }
    setCategoriesOrder(newData);
  }, [Menus, Categories?.data, data]);

  /* ===== RENDER ===== */
  return (
    <>
      {isLoading && (
        <LoadingPage text={'데이터를 처리중입니다. 잠시만 기다려주세요.'} />
      )}
      <CategoryListPresenter
        data={data}
        categoriesOrder={categoriesOrder}
        modalData={modalData}
        modalType={modalType}
        isOpened={isOpened}
        onOpen={handleModal}
        onChange={handleChange}
        onSubmit={handleSubmit}
        onDelete={handleDeleteSelected}
        onDrop={handleDrop}
        onUpdateOrder={handleUpdateOrder}
      />
    </>
  );
};

export default CategoryListContainer;
